import { render } from "./editModule.vue?vue&type=template&id=6bef1e96"
import script from "./editModule.vue?vue&type=script&lang=js"
export * from "./editModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__